export default __webpack_public_path__ + "media/4d8029ac62ed83d6d3639379df7a58467a56f64aecb4c8de3a9f6c759da3bebc.svg";